import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";
import { myFeatureRequests } from "../../api/features";
import { NeuCard } from "../../components/neu/Neu";
import { RequestFeatureButton } from "../../components/layout/RequestFeatureButton";

// الميزات المغلقة لشركتك مع زر طلب التفعيل لكل واحدة (تصل لمالك المنصة).
export const AvailableFeatures = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    myFeatureRequests().then(setData).catch(() => setData(null));
  }, []);

  if (!data) return null;

  return (
    <NeuCard data-testid="available-features-card">
      <p className="label-xs flex items-center gap-2">
        <Sparkles className="h-4 w-4 text-primary" /> {t("features.availableTitle")}
      </p>
      <p className="mt-1 text-xs text-muted-foreground">{t("features.availableHint")}</p>

      {data.closed.length ? (
        <div className="mt-4 grid gap-2">
          {data.closed.map((key) => (
            <div
              key={key}
              className="flex flex-wrap items-center gap-3 rounded-2xl p-3 shadow-neu-in"
              data-testid={`available-feature-${key}`}
            >
              <span className="min-w-0 flex-1 truncate text-xs font-bold">{t(`features.names.${key}`)}</span>
              <RequestFeatureButton feature={key} initialAsked={data.requested.includes(key)} />
            </div>
          ))}
        </div>
      ) : (
        <p className="mt-4 text-sm font-bold text-primary" data-testid="all-features-on">
          {t("features.allEnabled")}
        </p>
      )}
    </NeuCard>
  );
};
